/*
 * @Description:
 * @Date: 2024-11-25 19:52:23
 */
import { DirectiveBinding } from 'vue';
import appStore from '@/store';
// import { storeToRefs } from 'pinia';
const getUserResource = (): string[] => {
  const resource = appStore.useResourceStoreSetup.resource;
  return resource?.map(item => item.name) || []; // TODO: 可能出现undefined？未解决
};
// <button v-resource="['admin']">Admin Only Button</button>

const checkPermission = (el: HTMLElement, binding: DirectiveBinding) => {
  const requiredResource = binding.value;
  const userResource = getUserResource();
  if (userResource) {
    if (!requiredResource.some(resource => userResource.includes(resource))) {
      el.remove();
    }
  }
};
export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding);
  }
};
